
import Vue from "vue";

export default Vue.extend({
  name: "FeatureBox",
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  },
  methods: {
    isArabicLocale(): boolean {
      return localStorage.getItem("locale") === "ar";
    }
  }
});
